
import OBSUploader  from './Uploader';

export default OBSUploader;
